import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/registers/login'
import Index from '../views/index/index'
import Search from '../views/index/search'
import DataCode from '../views/data/index'
import Details from '../views/data/details'
import User from '../views/users/index'
import Setting from '../views/users/setting'
import UserEdit from '../views/users/edit'
import Questions from '../views/users/questions'
import Orders from '../views/orders/index'
import OrdersShow from '../views/orders/show'
import Scan from '../views/orders/scan'
import Income from '../views/users/income'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: '首页',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: {
        title: '防伪查询',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录'
      },
    },
    {
      path: '/details',
      name: 'details',
      component: Details,
      meta: {
        title: '防伪查询'
      },
    },
    {
      path: '/data/index',
      name: 'DataCode',
      component: DataCode,
      meta: {
        title: '码库',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/index',
      name: 'user',
      component: User,
      meta: {
        title: '我的',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/setting',
      name: 'Setting',
      component: Setting,
      meta: {
        title: '基础设置',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/questions',
      name: 'Questions',
      component: Questions,
      meta: {
        title: '常见问题',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      meta: {
        title: '订单',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/orders/show',
      name: 'ordersShow',
      component: OrdersShow,
      meta: {
        title: '订单详情',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/orders/scan',
      name: 'scan',
      component: Scan,
      meta: {
        title: '扫码发货',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/edit',
      name: 'userEdit',
      component: UserEdit,
      meta: {
        title: '个人资料',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/income',
      name: 'income',
      component: Income,
      meta: {
        title: '收支明细',
        show: true,
        requireAuth: true,
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js